
















































































































































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { SheetListCondition, RowSpanInfo } from "../../modules/teacher/SheetList"


export interface Data {
  condition: SheetListCondition
  sheets: any[]
  totalCount: number
  sheetRowSpanInfos: RowSpanInfo[]
  school_id: number
  errors: string[]
  isShow: boolean
  ApiTypeEnum: Readonly<{None: number; Classroom: number; Teams: number}>
  selectedSheet: any
  users: any[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    const modalDigitalPaperPublishSetting = ref<InstanceType<typeof BModal>>();
    const modalTeamsAdminConsentHelp = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.sheetListCondition,
      sheets: [],
      totalCount: 0,
      sheetRowSpanInfos: new Array<RowSpanInfo>(),
      school_id: context.root.$store.state.currentUser.school_id,
      errors: [],
      isShow: false,
      ApiTypeEnum: Common.ApiTypeEnum,
      selectedSheet: null,
      users: [],
    });

    const openDigitalPaperPublishSettingModal = (sheet: any) => {
      state.selectedSheet = sheet;
      modalDigitalPaperPublishSetting.value.show();
    }

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        const sheets = response.data.sheets;

        var sheetRowSpanInfos = [];
        for(var i = 0; i < sheets.length; i++){
          var sheet = sheets[i];
          if(sheetRowSpanInfos.length == 0 || sheetRowSpanInfos[sheetRowSpanInfos.length - 1].sheet_group_key != sheet.sheet_group_key){
            sheetRowSpanInfos.push({sheet_id: sheet.id, sheet_group_key: sheet.sheet_group_key, count: 1});
          }else{
            sheetRowSpanInfos[sheetRowSpanInfos.length - 1].count++;
          }
        }
        state.sheetRowSpanInfos = sheetRowSpanInfos;

        state.totalCount = sheets.length > 0 ? sheets[0].full_count : 0;
        state.sheets = sheets;
        state.sheets.forEach((x: any) => {
          x["digital_sheet_published_cache"] = x.digital_sheet_published;
        });

        state.users = response.data.users;

        context.root.$store.commit("setSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 処理時間列用に時分秒表示にコンバート
     ******************************/

    const convertToHms = (time: number) => {
      var hms = "";
      var h = time / 3600 | 0;
      var m = time % 3600 / 60 | 0;
      var s = time % 60;

      if (h != 0) {
        hms = h + "時間" + padZero(m) + "分" + padZero(s) + "秒";
      } else if (m != 0) {
        hms = m + "分" + padZero(s) + "秒";
      } else {
        hms = s + "秒";
      }

      return hms;
    };

    /******************************
     * ゼロ埋め
     ******************************/

    const padZero = (v: number) => {
      if (v < 10) {
        return "0" + v;
      }
      else {
        return v;
      }
    };

    /******************************
     * rowspan設定
     ******************************/

    const rowSpan = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? rowInfo[0].count : 1;
    }

    /******************************
     * セルのスタイル設定
     ******************************/

    const tdStyle = (sheet: any) => {
      const rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_id == sheet.id);
      return rowInfo.length > 0 ? {} : {"display": "none"};
    };

    /******************************
     * 行のCSSスタイル設定
     ******************************/

    const trStyle = (sheet: any) => {
      var rowInfo = state.sheetRowSpanInfos.filter(x => x.sheet_group_key == sheet.sheet_group_key);
      if(rowInfo.length > 0){
        var rowIdx = state.sheetRowSpanInfos.indexOf(rowInfo[0]);
        return rowIdx % 2 == 1 ? {"background-color": "#f2f2f2"} : {};
      }
    };

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * 採点設定完了状態
     ******************************/

    const isSettingCompleted = (sheet: any) => {
      if(sheet.is_digital_paper){
        return sheet.answer_image_completed;
      }else if(sheet.is_recog_position_edit_enable){
        return sheet.recog_positions_completed;
      }else{
        return sheet.score_positions_completed;
      }
    }

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      const pageCache = state.condition.page;
      state.condition = new SheetListCondition();
      state.condition.page = pageCache;
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験追加ボタン押下
     ******************************/

    const addSheetClick = () => {
      context.root.$router.push('/teacher_site/sheet_edit/new').catch(err => {});
    };

    /******************************
     * 試験追加(デジタルペーパー)ボタン押下
     ******************************/

    const addDigitalRepostSheetClick = () => {
      context.root.$router.push('/teacher_site/digital_paper_sheet_edit/new').catch(err => {});
    }

    /******************************
     * Classroom Api認証
     ******************************/

    const classroomAuthorize = async (to_path: string) => {
      if (!context.root.$store.state.gauthCredentials) {
        context.root.$store.dispatch("showOverlay");
        document.cookie = "api_kind=classroom";
        await http.post(`/api/classroom_sessions/create`).then(response => {
          if (response.data.auth_uri) {
            context.root.$store.commit("setGauthRedirectPath", to_path);
            window.location.href = response.data.auth_uri;
          } else {
            state.errors = ["認証URLの取得に失敗しました。"];
          }
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        context.root.$store.dispatch("hideOverlay");
      } else {
        context.root.$router.push(to_path).catch(err => {});
      }
    };

    /******************************
     * Teams Api認証
     ******************************/

    const teamsAuthorize = async (to_path: string) => {
      state.errors = [];
      context.root.$store.commit("setGauthRedirectPath", to_path);
      window.location.href = `/api/azure_sessions/authorize_teams_user_consent?redirect_path=${encodeURIComponent(to_path)}`;
    };

    /******************************
     * Teams管理者承認画面へ遷移
     ******************************/

    const teamsAdminConsentAuthorize = () => {
      state.errors = [];
      context.root.$store.commit("setGauthRedirectPath", "/teacher_site/sheet_list");
      modalTeamsAdminConsentHelp.value.hide();
      window.location.href = `/api/azure_sessions/authorize_teams_admin_consent?redirect_path=${encodeURIComponent("/teacher_site/sheet_list")}`;
    };

    /******************************
     * メール答案返却
     ******************************/

    const sendAnswerImageMail = (sheet_id: number) => {
      context.root.$router.push(`/teacher_site/send_answer_image/mail/${sheet_id}`).catch(err => {});
    };

    /******************************
     * 採点設定アイコン押下
     ******************************/

    const saitenSettingClick = (sheet: any) => {

      context.root.$store.commit("setIsDigitalPaper", sheet.is_digital_paper);
      context.root.$store.commit("setIsRecogPositionEditEnable", sheet.is_recog_position_edit_enable);

      // 採点設定の進捗により遷移先を制御
      if(sheet.is_digital_paper){
        if(sheet.answer_image_completed){
          context.root.$router.push(`/teacher_site/question_image_upload/${sheet.sheet_group_key}`).catch(err => {});
        }else if(sheet.score_positions_completed){
          if(sheet.is_recog_position_edit_enable){
            context.root.$router.push(`/teacher_site/recog_position_edit/${sheet.sheet_group_key}`).catch(err => {});
          }else{
            context.root.$router.push(`/teacher_site/answer_image_upload/${sheet.sheet_group_key}`).catch(err => {});
          }
        }else if(sheet.field_positions_completed){
          context.root.$router.push(`/teacher_site/score_position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }else if(sheet.corretct_image_completed){
          context.root.$router.push(`/teacher_site/position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }else if(sheet.field_names_completed){
          context.root.$router.push(`/teacher_site/correct_image_upload/${sheet.sheet_group_key}`).catch(err => {});
        }else{
          context.root.$router.push(`/teacher_site/digital_paper_field_edit/${sheet.sheet_group_key}`).catch(err => {});
        }
      }else{
        if(sheet.score_positions_completed){
          if(sheet.is_recog_position_edit_enable){
            context.root.$router.push(`/teacher_site/recog_position_edit/${sheet.sheet_group_key}`).catch(err => {});
          }else{
            context.root.$router.push(`/teacher_site/score_position_edit/${sheet.sheet_group_key}`).catch(err => {});
          }
        }else if(sheet.field_positions_completed){
          context.root.$router.push(`/teacher_site/score_position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }else if(sheet.corretct_image_completed){
          context.root.$router.push(`/teacher_site/position_edit/${sheet.sheet_group_key}`).catch(err => {});
        }else if(sheet.field_names_completed){
          context.root.$router.push(`/teacher_site/correct_image_upload/${sheet.sheet_group_key}`).catch(err => {});
        }else{
          context.root.$router.push(`/teacher_site/field_edit/${sheet.sheet_group_key}`).catch(err => {});
        }
      }
    };

    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * admin権限で表示される学校プルダウン変更
     ******************************/

    const schoolChanged = async () => {

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_admin_school/${state.school_id}`).then(response => {
        clearCondition();
        context.root.$store.commit("setSheetListCondition", state.condition);
        context.root.$store.commit("setCurrentUserSchoolId", state.school_id);
        context.root.$store.commit("setCurrentUserSchoolOptions", response.data.school_options);
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 採点結果の公開状態切り替え
     ******************************/

    const updateResultPublished = async (sheet: any) => {
      if(!window.confirm("公開状態を切り替えます。よろしいですか？")){
        return;
      }
      const flg = !sheet.result_published;
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_result_published/${sheet.sheet_group_key}`, {flg: flg}).then(response => {
        state.sheets.filter(x => x.sheet_group_key == sheet.sheet_group_key).forEach(x => {
          x.result_published = flg;
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 採点結果画像の公開状態切り替え
     ******************************/

    const updateResultImagePublished = async (sheet: any) => {
      if(!window.confirm("公開状態を切り替えます。よろしいですか？")){
        return;
      }
      const flg = !sheet.result_image_published;
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_result_image_published/${sheet.id}`, {flg: flg}).then(response => {
        sheet.result_image_published = flg
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * デジタルペーパーの公開状態切り替え
     ******************************/

    const changeDigitalPublished = async (sheet: any, flg: boolean) => {
      
      if(!window.confirm("公開状態を切り替えます。よろしいですか？")){
        return;
      }
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_digital_sheet_published/${sheet.id}`, {flg: flg}).then(response => {
        alert("処理が完了しました。");
        //modalDigitalPaperPublishSetting.value.hide();
        state.sheets.filter(x => x.id == sheet.id).forEach(x => {
          x.digital_sheet_published = flg;
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * デジタルペーパーの公開予約
     ******************************/

    const updateDigitalPaperPublishSchedule = async (sheet: any) => {
      
      state.errors = [];

      if(!sheet.test_start_datetime_at && sheet.test_end_datetime_at){
        alert("開始日時が設定されていません。");
        return;
      }

      if(sheet.test_start_datetime_at && !sheet.test_end_datetime_at){
        alert("終了日時が設定されていません。");
        return;
      }

      if(!window.confirm("公開予約を登録します。よろしいですか？")){
        return;
      }

      const param = {
        test_start_datetime_at: sheet.test_start_datetime_at,
        test_end_datetime_at: sheet.test_end_datetime_at,
      };

      await http.post(`/api/teacher/sheet_list/update_digital_paper_publish_schedule/${sheet.id}`, param).then(response => {
        alert("処理が完了しました。");
        //modalDigitalPaperPublishSetting.value.hide();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsFilterMisaiten", null);
      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Normal);
      state.condition = context.root.$store.state.sheetListCondition;
      if(!context.root.$store.getters.isOptionSchoolSubjectActive && state.condition.subject_code){
        state.condition.subject_code = "";
      }
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      modalDigitalPaperPublishSetting,
      modalTeamsAdminConsentHelp,
      search,
      searchClick,
      convertToHms,
      rowSpan,
      tdStyle,
      trStyle,
      convertExecDate,
      isSettingCompleted,
      clearCondition,
      changePage,
      addSheetClick,
      addDigitalRepostSheetClick,
      classroomAuthorize,
      teamsAuthorize,
      teamsAdminConsentAuthorize,
      sendAnswerImageMail,
      saitenSettingClick,
      reload,
      schoolChanged,
      updateResultPublished,
      updateResultImagePublished,
      changeDigitalPublished,
      openDigitalPaperPublishSettingModal,
      updateDigitalPaperPublishSchedule,
    }
  }
});
